export default function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="py-20 text-center">
      {Icon && (
        <div className="w-12 h-12 rounded-lg bg-surface-2 border border-border mx-auto mb-4 grid place-items-center">
          <Icon className="w-5 h-5 text-ink-dim" />
        </div>
      )}
      <div className="font-display font-semibold">{title}</div>
      {description && <div className="text-xs text-ink-dim mt-1.5 font-mono max-w-sm mx-auto">{description}</div>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
